import { render, staticRenderFns } from "./InstrumentsList.vue?vue&type=template&id=356e66ca&scoped=true"
import script from "./InstrumentsList.vue?vue&type=script&lang=ts"
export * from "./InstrumentsList.vue?vue&type=script&lang=ts"
import style0 from "./InstrumentsList.vue?vue&type=style&index=0&id=356e66ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356e66ca",
  null
  
)

export default component.exports